import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { UpdateAgentFormData } from "../schema/UpdateAgentSchema";
import { AgentResponseSchema } from "../response/UpdateAgentResponse";

export const useUpdateAgent = () => {
    return useMutation({
        mutationFn: async (values: {
            agentId: string;
            formData: UpdateAgentFormData;
        }) => privateApi.put(`/v3/agent/${values.agentId}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = AgentResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update agent data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update agent', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid agent data format");
            } else {
                console.error('Failed to update agent', error);
                throw error;
            }
        },
    });
};